import { API } from '@/api/index';
export default {
    name: "Announcement",
    created() {

        this.$nextTick(function () {
            // localStorage.clear()
            this.GetAnnouncement()
            if (this.AnnouncementbarF == 1) {


                if (
                    localStorage.getItem("disclaimerchoice") != null) {
                    var today = new Date().getTime();
                    var result = (today - localStorage.getItem("disclaimerchoice"));
                    let twentyFourHours = 24 * 60 * 60 * 1000


                    if (Number(result) <= twentyFourHours) {
                        this.AnnouncementbarFLE = false


                    } else {
                        this.AnnouncementbarFLE = true
                    }
                }
            } else {


                if (
                    localStorage.getItem("disclaimerchoice") != null) {
                    var today = new Date().getTime();
                    var result = (today - localStorage.getItem("disclaimerchoice"));
                    let twentyFourHours = 24 * 60 * 60 * 1000

                    if (Number(result) <= twentyFourHours) {

                        this.AnnouncementbarFLE = false

                    } else {
                        this.AnnouncementbarFLE = true
                    }
                }
            }

        });
    },
    mounted() {
        this.$nextTick(function () {

        })
    },
    data() {
        return {
            Data: [],
            AnnouncementbarF: localStorage.getItem('Announcementbar'),
            AnnouncementbarFLE: true
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        async GetAnnouncement() {
            try {
                const result = await API.get('GetAnnouncement', { lang: localStorage.getItem('Language') || '1' });
                
                this.Data = result.data.slice(0, 3)


            } catch (error) {
                this.Data = []
                console.error('API Error:', error);
            } finally {
                setTimeout(() => {
                    $('.slick', '.announcementcarousel').slick({
                        vertical: true,
                        verticalSwiping: true,
                        slidesToShow: 1,
                        autoplay: true,
                        autoplaySpeed: 5000000, // 修正：5000000 毫秒太长了，改为 5000
                        centerMode: false,
                        dots: true,
                        autoplayHoverPause: true
                    });


                }, 10)

            }
        },
        Closeicon: function () {
            this.AnnouncementbarFLE = false
            if (localStorage.getItem("CookiesSettings") == "Close") {
                localStorage.setItem('Announcementbar', 1)
            }
            console.log(this.AnnouncementbarFLE);
            
            // $('#Announcementbar').addClass('hide');

            var today = new Date().getTime();
            localStorage.setItem("disclaimerchoice", today);

        },
        extractTextAndTruncate: function (htmlString, maxWords = 15) {
            // 建立一個暫存的 <div>，用來解析 HTML
            let tempDiv = document.createElement("div");
            tempDiv.innerHTML = htmlString;



            // 取得 div 內的純文字內容
            let text = tempDiv.innerText.trim();
            // 按空格拆分文字
            let words = text.split(/\s+/);

            // 如果超過 maxWords，就加上 "..."
            return words.length > maxWords ?
                words.slice(0, maxWords).join(" ") + " ..." :
                text;
        }
    },

};